import TemplateManager from './components/TemplateManager';

const App = () => (
  <div className="app">
    <main>
      <TemplateManager />
    </main>
  </div>
);

export default App;
